// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: q0oB5JbEtg1S
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicGetStarted.module.css"; // plasmic-import: q0oB5JbEtg1S/css

createPlasmicElementProxy;

export const PlasmicGetStarted__VariantProps = new Array();

export const PlasmicGetStarted__ArgProps = new Array("emailText");

const $$ = {};

function PlasmicGetStarted__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "merchantName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"dashboardLoginDarkTheme"}
            data-plasmic-override={overrides.dashboardLoginDarkTheme}
            className={classNames(projectcss.all, sty.dashboardLoginDarkTheme)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__c94Zo)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"frame1"}
                data-plasmic-override={overrides.frame1}
                hasGap={true}
                className={classNames(projectcss.all, sty.frame1)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__pD9VA
                  )}
                >
                  {hasVariant(globalVariants, "screen", "mobile")
                    ? "Welcome to CollectWise! "
                    : hasVariant(globalVariants, "screen", "medium")
                    ? "Welcome to CollectWise! Let's get started"
                    : "Welcome to CollectWise! Let's get started"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__qd4Xi
                  )}
                >
                  {
                    "We've detected that you're currently using CollectWise from a mobile device. For the best experience, we recommend switching to your computer first before getting started."
                  }
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__yaEyk)}>
                  {renderPlasmicSlot({
                    defaultContents: "Enter the name of your business:",
                    value: args.emailText,
                    className: classNames(sty.slotTargetEmailText)
                  })}
                </div>
                <input
                  data-plasmic-name={"merchantName"}
                  data-plasmic-override={overrides.merchantName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.merchantName
                  )}
                  onChange={async (...eventArgs) => {
                    (e => {
                      generateStateOnChangeProp($state, [
                        "merchantName",
                        "value"
                      ])(e.target.value);
                    }).apply(null, eventArgs);
                  }}
                  placeholder={"Company or Individual Name"}
                  ref={ref => {
                    $refs["merchantName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    generateStateValueProp($state, ["merchantName", "value"]) ??
                    ""
                  }
                />

                <button
                  data-plasmic-name={"nextButton"}
                  data-plasmic-override={overrides.nextButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.nextButton
                  )}
                  ref={ref => {
                    $refs["nextButton"] = ref;
                  }}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__aOi55
                    )}
                  >
                    {"Continue"}
                  </div>
                </button>
              </Stack__>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "dashboardLoginDarkTheme",
    "frame1",
    "merchantName",
    "nextButton"
  ],

  dashboardLoginDarkTheme: [
    "dashboardLoginDarkTheme",
    "frame1",
    "merchantName",
    "nextButton"
  ],

  frame1: ["frame1", "merchantName", "nextButton"],
  merchantName: ["merchantName"],
  nextButton: ["nextButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGetStarted__ArgProps,
          internalVariantPropNames: PlasmicGetStarted__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicGetStarted__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGetStarted";
  } else {
    func.displayName = `PlasmicGetStarted.${nodeName}`;
  }
  return func;
}

export const PlasmicGetStarted = Object.assign(
  // Top-level PlasmicGetStarted renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dashboardLoginDarkTheme: makeNodeComponent("dashboardLoginDarkTheme"),
    frame1: makeNodeComponent("frame1"),
    merchantName: makeNodeComponent("merchantName"),
    nextButton: makeNodeComponent("nextButton"),
    // Metadata about props expected for PlasmicGetStarted
    internalVariantProps: PlasmicGetStarted__VariantProps,
    internalArgProps: PlasmicGetStarted__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicGetStarted;
/* prettier-ignore-end */
